import React from "react";
import { Paper, Table, TableRow, TableCell, TableHead, TableBody, Typography } from "@mui/material";

interface DataItem {
  name: string;
  data: string | number;
}

interface DataComparisonGridProps {
  title: string;
  leftSubtitle: string;
  rightSubtitle: string;
  leftData: DataItem[];
  rightData: DataItem[];
}

const DataComparisonGrid: React.FC<DataComparisonGridProps> = ({
  title,
  leftSubtitle,
  rightSubtitle,
  leftData,
  rightData,
}) => {
  return (
    <Paper elevation={4} sx={{ mt: 3, boxShadow: 3, borderRadius: 2, overflow: "hidden" }}>
      <Typography variant="h6" align="center" sx={{ pt: 2, pb: 2, backgroundColor: "#fbeaec" }}>
        {title}
      </Typography>
      <Table sx={{ maxWidth: "100%", boxShadow: 3, borderRadius: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell align="center" sx={{ fontSize: "1rem", backgroundColor: "#f5f5f5" }}></TableCell>
            <TableCell align="center" sx={{ fontSize: "1rem", backgroundColor: "#f5f5f5" }}>
              {leftSubtitle}
            </TableCell>
            <TableCell align="center" sx={{ fontSize: "1rem", backgroundColor: "#f5f5f5", color: "#bf2f38" }}>
              {rightSubtitle}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leftData.map((data, idx) => (
            <TableRow
              key={idx}
              sx={{
                backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff",
              }}
            >
              <TableCell align="center" sx={{ fontSize: "0.9rem", color: "#222222" }}>
                {data.name}
              </TableCell>
              <TableCell align="center" sx={{ fontSize: "0.9rem", color: "#222222" }}>
                {data.data || "-"}
              </TableCell>
              <TableCell align="center" sx={{ fontSize: "0.9rem", color: "#bf2f38" }}>
                {rightData[idx]?.data || "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default DataComparisonGrid;
